export const REGENERATING_LABELS_MESSAGE =
  'One or more labels are currently being regenerated. The printed label may be stale. Please refresh the screen to get the latest labels.';

export const REGENERATE_LOCKED_BY_FILL_MESSAGE =
  'Uncheck "mark as Filled" to regenerate labels. Filling a product happens when the label is printed, not when it is regenerated.';

export default { REGENERATING_LABELS_MESSAGE, REGENERATE_LOCKED_BY_FILL_MESSAGE };
